export default __webpack_public_path__ + "static/media/contactEnvelop.1b960822.svg";